var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:_vm.classes,attrs:{"tabindex":null}},[(_vm.label)?_c('label',{class:{ required: _vm.required },domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_vm._t("default"),_c('has-error',{attrs:{"form":_vm.form,"field":_vm.name}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }